export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    close: '关闭',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    index: '序号',
    actions: '操作',
    total: '共 {total} 条'
  },

  footer: {
    copyright: '© 2023 - 氢和环保科技有限公司版权所有',
    techSupport: '粤ICP备2024268161号-1',
    icp: '备案号：',
  },

  // 登录页面
  login: {
    systemTitle:'氢和环保科技·富氢机',
    welcomeTitle:'欢迎登陆 - 富氢机后台管理系统',
    title: '氢和环保科技-后台管理',
    username: '用户名',
    password: '密码',
    login: '登录',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    getUserInfoFailed: '获取用户信息失败'
  },

  // 管理员页面
  admin: {
    title: '氢和环保科技-后台管理',
    dashboard: '仪表盘',
    logout: '退出登录',
    language: '语言',
    chinese: '中文',
    english: 'English',
    japanese: '日本語',
    spanish: 'Español',
    korean: '한국어',
    mexicanSpanish: 'Español Mexicano'
  },

  // 菜单
  menu: {
    equipment: '设备管理',
    equipmentLibrary: '设备&滤芯库',
    filterRecord: '换芯记录',
    version: '版本库',
    dataQuery: '数据查询',
    heartbeat: '心跳数据',
    singleUse: '单次使用数据',
    bindStats: '绑定数据统计',
    customer: '客户管理',
    agentCheck: '代理商审核',
    agentProfit: '代理商分润',
    promotionRoute: '推广路线',
    partyType: '甲方类型',
    mqttQuery: 'MQTT查询',
    statusQuery: '状态查询',
    outputRecord: '出水记录',
    debug: '设备调试页面',
    waterTotal: '水量统计',
    adminAccount: '管理员账号',
    deviceType: '设备类型',
    defaultSettings: '默认设置',
    flowConfig: '流量配置',
    waterConfig: '水量配置',
    businessLog: '业务日志',
    payment: '支付管理',
    order: '订单管理',
    statistics: '统计报表',
    waterPrice: '水价配置',
    recharge: '充值管理'
  },

  // 设备管理标题
  device: {
    title: '设备管理',
    equipmentId: '设备ID',
    equipmentType: '设备类型',
    status: '状态',
    iotCard: '物联卡',
    relatedOrg: '关联机构',
    city: '所在城市',
    actions: '操作',
    addEquipment: '添加设备&滤芯',
    exportEquipment: '导出设备',
    clearTestData: '一键清理测试数据',
    modifyCard: '改物联卡',
    transferOrg: '移交机构',
    modifyStatus: '修改状态',
    modifyLocation: '修改定位',
    modifyType: '修改类型',
    rechargeWater: '充值水量',
    rechargeRecord: '充值记录',
    generateQR: '生成二维码',
    allOrganizations: '全部机构',
    allTypes: '全部类型',
    allStatus: '全部状态',
    used: '使用中',
    unused: '未使用',
    offline: '离线',
    online: '在线',
    homeDevice: '家用型设备',
    sharedDevice: '共享型设备',
    homeFilter: '家用型滤芯',
    sharedFilter: '共享型滤芯',
    unknown: '未知',
    quantity: '数量',
    iotCardPlaceholder: '请输入物联卡号',
    filterQuantityPlaceholder: '请输入滤芯数量',
    equipmentIdRequired: '请输入设备ID',
    equipmentTypeRequired: '请选择设备类型',
    statusRequired: '请选择状态',
    iotCardRequired: '请输入物联卡号',
    quantityRequired: '请输入数量',
    quantityMustBeNumber: '数量必须是数字',
    quantityMustBePositive: '数量必须大于0',
    addSuccess: '添加成功',
    exportSuccess: '导出成功',
    clearSuccess: '清理成功',
    modifySuccess: '修改成功',
    qrGenerateSuccess: '二维码生成成功',
    qrGenerateFailed: '二维码生成失败',
    enterEquipmentId: '请输入设备ID',
    generateDate: '生成日期',
    
    // 设备类型管理
    typeCode: '设备类型编号',
    typeName: '设备类型名称',
    selectOrganization: '请选择机构',
    typeCodePlaceholder: '请输入类型编号',
    typeNamePlaceholder: '请输入设备类型名称',
    typeCodeRequired: '类型编号必填',
    typeNameRequired: '类型名称必填',
    addType: '添加类型',
    editType: '编辑类型',
    deleteConfirm: '确定要删除设备类型 "{name}" 吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    getDataFailed: '获取数据失败',
    organization: '机构',
    universal: '通用',
    defaultOutVol: '默认出水量(矿机)',
    outVolRequired: '默认出水量必填',
    changeRule: '换芯计算规则',
    filterAlgorithm: '滤芯算法',
    byVolume: '按流量',
    byTime: '按时间',
    none: '无',
    ruleDescription: '换芯计算规则：',
    volumeRule: '1：按流量计算（比如：1-4号芯，每40000L一换）',
    timeRule: '2：按时间计算（比如：1年，60000L）',
    selectDate: '选择日期',
    offlineDays: '离线天数',
    offlineDaysPlaceholder: '天数',
    clearTestConfirm: '是否确认清理所有测试数据？此操作不可撤销！',
    clearTestSuccess: '清理测试数据成功',
    clearTestFailed: '清理测试数据失败',
    addFailed: '添加失败',
    selectEquipmentType: '请选择设备类型',
    enterQuantity: '请输入数量',
    generateTime: '生成时间',
    activateTime: '激活时间',
    onlineStatus: '在线状态',
    notMqttOrNotStarted: '非MQTT或未启动',
    filterReminder: '滤芯提醒',
    filterNumber: '滤芯',
    days: '天',
    remainingWater: '剩余水量',
    lastHeartbeat: '最后心跳',
    qrCode: '二维码',
    notBound: '未绑定',
    changeCard: '改物联卡',
    updateStatus: '修改状态',
    updateLocation: '修改定位',
    updateType: '修改类型',
    waterRecord: '充值记录'
  },

  // 机构管理标题
  org: {
    title: '机构管理'
  },

  // 系统设置标题
  setting: {
    title: '系统设置',
    setName: '设置名',
    setValue: '设置值',
    remark: '备注',
    setNamePlaceholder: '请输入设置名',
    setValuePlaceholder: '请输入设置值',
    remarkPlaceholder: '请输入备注',
    setNameRequired: '设置名必填',
    setValueRequired: '设置值必填',
    addSetting: '添加设置',
    editSetting: '编辑设置',
    deleteConfirm: '确定要删除设置 "{name}" 吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    getDataFailed: '获取数据失败'
  },

  // 流量配置
  flowConfig: {
    title: '出水流量映射个性化设置',
    equipmentId: '设备编号',
    outVol: '出水流量',
    volMap: '映射流量',
    equipmentIdPlaceholder: '请输入设备编号',
    outVolPlaceholder: '请输入出水流量',
    volMapPlaceholder: '请输入映射流量',
    equipmentIdRequired: '设备编号必填',
    outVolRequired: '出水流量必填',
    volMapRequired: '映射流量必填',
    addSetting: '添加设置',
    editSetting: '编辑设置',
    deleteConfirm: '确定要删除设备 "{equId}" 的流量配置吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    getDataFailed: '获取数据失败'
  },

  // 业务日志
  log: {
    title: '系统业务日志',
    equipmentId: '设备编号',
    keyword: '关键字',
    logType: '日志类型',
    equipmentIdPlaceholder: '请输入设备编号',
    keywordPlaceholder: '请输入关键字',
    logTypePlaceholder: '请选择日志类型',
    allTypes: '日志类型(全部)',
    error: 'ERROR(错误)',
    info: 'Info(记录)',
    warn: 'Warn(警告)',
    unknown: '无',
    logTitle: '标题',
    message: '信息(参数或返回值)',
    exception: '异常',
    timestamp: '日志记录时间',
    getDataFailed: '获取数据失败'
  },

  // 换芯记录
  filterRecord: {
    title: '设备换芯记录查询',
    equipmentId: '设备编号',
    enterEquipmentId: '请输入设备编号',
    equipmentIdRequired: '设备编号必填',
    equipmentType: '设备类型',
    allTypes: '全部类型',
    filterType: '滤芯类型',
    changeTime: '更换时间',
    changeReason: '更换原因',
    changePerson: '更换人员',
    remark: '备注',
    homeFilter: '家用型滤芯',
    sharedFilter: '共享型滤芯',
    unknown: '未知',
    filterId: '滤芯ID',
    filterNumber: '滤芯编号',
    number: '号',
    filter: '滤芯'
  },

  // 版本库
  versionLibrary: {
    title: '版本库管理',
    versionNumber: '版本号',
    status: '状态',
    equipmentType: '设备类型',
    fileName: '文件名',
    md5Checksum: 'MD5校验',
    updateLog: '更新日志',
    authorizedCities: '授权城市',
    publishTime: '发布时间',
    actions: '操作',
    publishNewVersion: '发布新版本',
    editVersion: '编辑版本',
    deleteVersion: '删除版本',
    download: '下载',
    authorize: '授权',
    uploadFile: '上传文件',
    selectFile: '选择文件',
    versionNumberRequired: '请输入版本号',
    equipmentTypeRequired: '请选择设备类型',
    fileNameRequired: '请输入文件名',
    updateLogRequired: '请输入更新日志',
    publishSuccess: '发布成功',
    editSuccess: '编辑成功',
    deleteSuccess: '删除成功',
    downloadSuccess: '下载成功',
    authorizeSuccess: '授权成功',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    deleteConfirm: '是否确认删除？',
    authorizeConfirm: '是否确认授权？',
    enterVersionNumber: '请输入版本号',
    allStatus: '全部状态',
    published: '已发布',
    unpublished: '未发布',
    allTypes: '全部类型',
    edit: '编辑',
    versionNumberPlaceholder: '请输入版本号',
    dragFileText: '将文件拖到此处，或',
    uploadTip: '点击上传',
    publish: '发布',
    unpublish: '不发布',
    updateLogPlaceholder: '请输入更新日志',
    versionAuthorization: '版本授权',
    authorizedRegions: '授权地区',
    allRegions: '全部地区'
  },

  // 心跳数据
  heartbeat: {
    title: '心跳数据上报查询',
    equipmentId: '设备编号',
    enterEquipmentId: '请输入设备编号',
    equipmentIdRequired: '设备编号必填',
    equipmentType: '设备类型',
    allTypes: '全部类型',
    totalWaterVolume: '总出水量',
    errorCode: '错误代码',
    statusCode: '状态代码',
    boardCommunication: '板端通讯',
    heaterCommunication: '即热通讯',
    reportTime: '上报时间',
    boardComNormal: '正常',
    boardComError: '异常',
    heaterComNormal: '正常',
    heaterComError: '异常',
    homeDevice: '家用型设备',
    sharedDevice: '共享型设备',
    homeFilter: '家用型滤芯',
    sharedFilter: '共享型滤芯',
    unknown: '未知'
  },

  // 单次使用数据
  customerRecord: {
    title: '单次使用数据查询',
    equipmentId: '设备编号',
    enterEquipmentId: '请输入设备编号',
    equipmentIdRequired: '设备编号必填',
    equipmentType: '设备类型',
    allTypes: '全部类型',
    actionType: '操作类型',
    singleWaterVolume: '单次出水量ml',
    operationTime: '操作时间',
    iceWater: '冰水',
    normalWater: '常温水',
    water45: '45℃水',
    water60: '60℃水',
    water75: '75℃水',
    water95: '95℃水',
    oneClickClean: '一键清洗',
    changeFilter: '更换滤芯',
    oneClickEmpty: '一键排空',
    other: '其他'
  },

  // 绑定数据统计相关
  activeData: {
    title: '设备绑定信息统计查询',
    equipmentId: '设备编号',
    enterEquipmentId: '请输入设备编号',
    equipmentIdRequired: '设备编号必填',
    equipmentType: '设备类型',
    allTypes: '全部类型',
    exportData: '导出数据',
    modifyData: '修改数据',
    modifyWaterVolume: '修改出水量',
    activeTime: '激活时间',
    storeName: '门店名称',
    userName: '用户名称',
    userPhone: '用户电话',
    address: '地址',
    stageWaterVolume: '阶段总出水量(ml)',
    totalWaterVolume: '累计总出水量(ml)',
    recentDispenseTime: '最近出水时间',
    recentCleanTime: '最近清洁时间',
    usedDays: '已使用时长(天)',
    waterVolumeRequired: '阶段出水量必填',
    usedDaysRequired: '已使用时长必填',
    modifySuccess: '修改成功',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    homeDevice: '家用型设备',
    sharedDevice: '共享型设备',
    homeFilter: '家用型滤芯',
    sharedFilter: '共享型滤芯',
    unknown: '未知'
  },

  // 客户管理
  orgAdmin: {
    customerName: '客户名称',
    customerNamePlaceholder: '请输入客户名称',
    keyword: '关键词',
    keywordPlaceholder: '请输入关键词',
    type: '类型',
    status: '状态',
    allTypes: '类型(全部)',
    allStatus: '状态(全部)',
    agent: '代理商',
    dealer: '经销商',
    official: '官方',
    valid: '有效',
    invalid: '已失效',
    deleted: '已删除',
    other: '其他',
    add: '添加',
    detail: '详情',
    edit: '编辑',
    viewSecret: '查看密钥',
    delete: '删除',
    copy: '复制',
    addOrg: '添加机构',
    editOrg: '编辑机构',
    orgName: '机构名称',
    orgCode: '机构账号',
    orgType: '机构类型',
    address: '机构地址',
    contact: '机构联系人',
    phone: '机构联系电话',
    orgNumber: '组织机构代码',
    businessLicense: '营业执照URL',
    legalName: '法人姓名',
    legalIdPhoto: '法人身份证照片',
    legalIdNumber: '法人身份证号',
    legalPhone: '法人电话',
    remark: '备注',
    createTime: '创建时间',
    updateTime: '修改时间',
    checkTime: '审核时间',
    deleteTime: '删除时间',
    manageId: '管理编号',
    secretId: 'secretId',
    secretKey: 'secretKey',
    orgNameRequired: '请输入机构名称',
    orgCodeRequired: '请输入机构账号',
    orgTypeRequired: '请选择机构类型',
    statusRequired: '请选择状态',
    deleteConfirm: '是否确认删除？',
    deleteSuccess: '删除成功',
    saveSuccess: '保存成功',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    uploadBusinessLicense: '上传营业执照',
    uploadLegalIdPhoto: '上传法人身份证',
    viewImage: '查看图片',
    noImage: '暂无图片',
    uploadImageOnly: '只能上传图片文件',
    uploadSizeLimit: '图片大小不能超过10MB',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败'
  },

  // 代理商审核
  agentCheck: {
	orgCode:'机构账号',
    title: '代理商审核',
    orgName: '机构名称',
    orgNamePlaceholder: '请输入机构名称',
    applyStatus: '申请状态',
    allStatus: '全部状态',
    pending: '待审核',
    approved: '已通过',
    rejected: '已拒绝',
    contact: '联系人',
    phone: '联系电话',
    applyTime: '申请时间',
    applyReason: '申请理由',
    actions: '操作',
    audit: '审核',
    view: '查看详情',
    auditTitle: '代理商审核',
    viewTitle: '申请详情',
    address: '机构地址',
    legalName: '法人姓名',
    legalPhone: '法人电话',
    auditResult: '审核结果',
    approve: '通过',
    reject: '拒绝',
    auditRemark: '审核备注',
    auditRemarkPlaceholder: '请输入审核备注',
    submitAudit: '提交审核',
    auditStatusRequired: '请选择审核结果',
    auditRemarkRequired: '请输入审核备注',
    auditSuccess: '审核成功',
    auditFailed: '审核失败',
    unknown: '未知'
  },

  // 代理商分润管理
  agentCps: {
    title: '代理商分润管理',
    recordQuery: '分润记录查询',
    statistics: '代理商分润统计',
    settlement: '分润结算管理',
    orderId: '订单ID',
    orderIdPlaceholder: '请输入订单ID',
    agentId: '代理商ID',
    agentIdPlaceholder: '请输入代理商ID',
    status: '状态',
    allStatus: '全部状态',
    pending: '待结算',
    settled: '已结算',
    cancelled: '已取消',
    batchSettle: '批量结算',
    orderNo: '订单编号',
    agentName: '代理商',
    libName: '机构类型',
    level: '层级',
    commissionAmount: '分润金额',
    commissionRate: '分润比例(%)',
    orderAmount: '订单金额',
    createTime: '创建时间',
    settle: '结算',
    view: '查看',
    startTime: '开始时间',
    startTimePlaceholder: '开始时间',
    endTime: '结束时间',
    endTimePlaceholder: '结束时间',
    searchStats: '查询统计',
    commissionStats: '分润统计',
    commissionTrend: '分润趋势',
    totalAmount: '总分润金额',
    totalRecords: '分润记录数',
    noStatsData: '暂无统计数据',
    trendPlaceholder: '趋势图表功能待实现',
    settleAll: '结算所有待结算分润',
    exportSettle: '导出结算报表',
    settleConfirm: '确定要结算该分润记录吗？',
    settleSuccess: '结算成功',
    settleFailed: '结算失败',
    selectRecords: '请先选择要结算的记录',
    noPendingRecords: '没有待结算的记录',
    batchSettleConfirm: '确定要批量结算选中的分润记录吗？',
    batchSettleSuccess: '批量结算成功',
    batchSettleFailed: '批量结算失败',
    settleAllConfirm: '确定要结算所有待结算的分润记录吗？',
    settleAllSuccess: '结算所有成功',
    settleAllFailed: '结算所有失败',
    exportFeature: '导出功能待实现',
    viewFeature: '查看详情功能待实现',
    agentIdRequired: '请输入代理商ID',
    unknown: '未知'
  },

  // 设备调试页面
  equStatus: {
    title: '设备调试页面',
    equId: '设备编号',
    equIdPlaceholder: '请输入设备编号',
    equIdRequired: '设备编号必填',
    queryFailed: '查询失败',
    hardwareVersion: '硬件版本',
    softwareVersion: '软件版本',
    softwareDate: '软件日期',
    deviceNumber: '设备编号',
    heartbeatValue: '心跳值',
    status: '状态',
    fault: '故障',
    digitalInput: '开关量输入',
    digitalOutput: '开关量输出',
    waterMachineStep: '水机工步',
    waterMachineStepTimer: '水机工步计时',
    outletType: '出水类型',
    outletTargetTemperature: '出水目标温度',
    outletTargetFlow: '出水目标流量',
    outletActualTemperature: '出水实际温度',
    outletActualFlow: '出水实际流量',
    waterMakingStep: '制水工步',
    waterMakingStepTimer: '制水工步计时（秒）',
    waterShortageStep: '缺水工步',
    waterShortageStepTimer: '缺水工步计时（秒）',
    lightBarStep: '灯带工步',
    lightBarStepTimer: '灯带工步计时（秒）',
    instantHeatStep: '即热工步',
    instantHeatInletTemperature: '即热进水温度',
    instantHeatOutletTemperature: '即热出水温度',
    instantHeatOutflow: '即热出水量',
    instantHeatFailureCount: '即热失败计数',
    instantHeatHeating: '即热加热中（0: 否, 1: 是）',
    instantHeatFaultCode: '即热故障码',
    hydrogenRichModuleStep: '富氢模块工步',
    hydrogenRichModuleStepTimer: '富氢模块工步计时（秒）',
    autoClean24HTimer: '24H自动清洁计时（秒）',
    autoClean20LCountdownLiters: '20L自动清洁倒计公升数',
    ionFilterCleanRemainingTime1: '离子滤芯清洁剩余时间1（秒）',
    ionFilterCleanRemainingTime2: '离子滤芯清洁剩余时间2（秒）',
    ionFilterCleanRemainingTime3: '离子滤芯清洁剩余时间3（秒）',
    filterModuleStep: '滤芯模块工步',
    filterModuleStepTimer: '滤芯模块工步计时（秒）',
    filterCleanRemainingTime: '滤芯清洁剩余时间（单位：秒）',
    // 新增字段翻译
    interactionModuleVolume: '交互模块出水量',
    cupRecognitionModuleId: '水杯识别模块ID',
    reserved: '预留',
    bop1: 'BOP1',
    bop2: 'BOP2',
    bop1Error: 'BOP1Error',
    bop2Error: 'BOP2Error',
    bc12Current: 'BC12电流',
    bc34Current: 'BC34电流',
    scG1Current: 'SC_G1电流',
    scG2Current: 'SC_G2电流',
    referenceVoltage: '参考电压',
    ntc1: 'ntc1',
    ntc2: 'ntc2',
    onboardTemperatureSensor: '板载温度传感器',
    roPureWaterTds: 'RO纯水TDS',
    hydrogenRichModuleTds: '富氢模块TDS',
    supplyVoltage: '供电电压',
    inletFlowMeterFrequency: '进水流量计频率',
    inletFlow: '进水流量',
    inletAccumulatedVolume: '进水累计',
    outletFlowMeterFrequency: '出水流量计频率',
    outletFlow: '出水流量',
    outletAccumulatedVolume: '出水累计',
    filterUsageDuration: '滤芯使用时长（秒）',
    filterUsageLiters: '滤芯使用公升数',
    utc8Time: 'UTC+8时间',
    simCardNumber1: 'SIM卡号1',
    simCardNumber2: 'SIM卡号2',
    simCardNumber3: 'SIM卡号3',
    // 新增遗漏字段
    outletTargetDuration: '出水目标时长',
    outletCurrentTemperature: '出水当前温度',
    outletCurrentFlow: '出水当前流量',
    outletCurrentDuration: '出水当前时长',
    humanDistance: '人体距离',
    interactionModuleCommand: '交互模块-命令',
    simCardNumber4: 'SIM卡号4',
    simCardNumber5: 'SIM卡号5',
    fourGSignalStrength: '4G信号强度',
    cellInfo1: '基站-MNC',
    cellInfo2: '基站-CID',
    cellInfo3: '基站-LAC',
    fourGStep: '4G工步',
    // 新增遗漏字段翻译
    fourGStepTimer: '4G工步计时（秒）',
    mqttStep: 'MQTT工步',
    mqttStepTimer: 'MQTT工步计时（秒）',
    mqttPublishStep: 'MQTT发布工步',
    mqttPublishStepTimer: 'MQTT发布计时（秒）',
    reservedField1: '预留字段1',
    reservedField2: '预留字段2',
    reservedField3: '预留字段3',
    reservedField4: '预留字段4',
    httpStep: 'HTTP工步',
    httpStepTimer: 'HTTP工步计时（秒）',
    outletStep: '出水工步',
    outletStepTimer: '出水工步计时（秒）',
    normalWaterStep: '常温水工步',
    normalWaterStepTimer: '常温水工步计时（秒）',
    normalWaterOutflow: '常温水出水量',
    normalWaterOutflowTimer: '常温水出水计时（秒）',
    hotWaterStep: '热水工步',
    hotWaterStepTimer: '热水工步计时（秒）',
    hotWaterOutflow: '热水出水量',
    hotWaterOutflowTimer: '热水出水计时（秒）'
  },

  // MQTT出水记录查询
  statusDetail: {
    title: 'MQTT订单数据查询',
    equId: '设备编号',
    equIdPlaceholder: '请输入设备编号',
    equIdRequired: '设备编号必填',
    requestId: '出水记录号',
    operaTime: '创建时间',
    type: '出水类型',
    bagful: '订单袋数',
    volumn: '每袋水量·ml',
    outwaterTime: '出水时间',
    bagfulOD: '实际袋数',
    volumnTTLOD: '总出水量·ml',
    closewaterTime: '结束时间',
    status: '订单状态',
    waterDetail: '出水明细',
    queryFailed: '查询失败',
    detailFailed: '获取明细失败',
    iceWater: '冰水',
    normalWater: '常温水',
    warmWater45: '45℃水',
    warmWater75: '75℃水',
    hotWater95: '95℃水',
    other: '其他',
    created: '订单已创建',
    watering: '正在出水',
    completed: '完成',
    abnormalClose: '异常关闭',
    detailRequestId: '订单编号',
    detailBagful: '第几袋',
    detailVolumn: '每袋水量·ml',
    volumnOD: '实际出水量·ml',
    usedTimeOD: '用时·秒',
    detailClosewaterTime: '完成时间'
  },

  // MQTT设备状态查询
  statusAdmin: {
    title: 'MQTT设备状态查询',
    equId: '设备编号',
    equIdPlaceholder: '请输入设备编号',
    equIdRequired: '请输入设备编号',
    onLineStatus: '在线状态',
    heartbitStatus: '机器状态',
    digitalInput: '开关量输入',
    digitalOutput: '开关量输出',
    waterMachineStep: '水机工步',
    errStatus: '故障码',
    active: '激活时间',
    volumn: '使用流量·ml',
    waterRecord: '出水记录',
    filterRecord: '换芯记录',
    deviceDetail: '设备详情',
    online: '设备在线',
    offline: '设备离线',
    notActivated: '设备未激活',
    noInput: '无输入',
    noOutput: '无输出',
    none: '无',
    queryFailed: '查询失败',
    orgName: '机构名称',
    orgCode: '机构账号',
    orgType: '类型',
    status: '状态',
    orgAddress: '机构地址',
    orgLinkName: '机构联系人',
    orgLinkPhone: '机构联系电话',
    orgNumber: '组织机构代码',
    orgUrl: '营业执照URL',
    orgOwner: '法人姓名',
    orgOwnerUrl: '法人身份证照片',
    orgOwnerID: '法人身份证号',
    orgOwnerPhone: '法人电话',
    createTime: '创建时间',
    updateTime: '修改时间',
    checkTime: '审核时间',
    deleteTime: '删除时间',
    remark: '备注',
    official: '官方',
    agent: '代理',
    dealer: '经销',
    valid: '有效',
    invalid: '无效',
    deleted: '已删除'
  },

  // 推广路线配置
  routeConfig: {
    routeManagement: '推广路线管理',
    configSettings: '路线配置设置',
    recordQuery: '分润记录查询',
    routeName: '路线名称',
    routeNamePlaceholder: '请输入路线名称',
    routeCode: '路线编码',
    routeCodePlaceholder: '请输入路线编码',
    description: '路线描述',
    descriptionPlaceholder: '请输入路线描述',
    status: '状态',
    allStatus: '全部状态',
    enabled: '启用',
    disabled: '禁用',
    configCount: '配置数量',
    createTime: '创建时间',
    addRoute: '添加路线',
    edit: '编辑',
    config: '配置',
    enable: '启用',
    disable: '禁用',
    delete: '删除',
    selectRoute: '选择路线',
    selectRoutePlaceholder: '请选择推广路线',
    loadConfig: '加载配置',
    saveConfig: '保存配置',
    addConfig: '添加配置',
    libName: '机构类型',
    level: '层级',
    levelPlaceholder: '请输入层级（1-10）',
    commissionRate: '分润比例(%)',
    commissionRatePlaceholder: '请输入分润比例',
    minAmount: '最小金额',
    minAmountPlaceholder: '请输入最小金额',
    maxAmount: '最大金额',
    maxAmountPlaceholder: '请输入最大金额',
    orderId: '订单ID',
    orderIdPlaceholder: '请输入订单ID',
    agentId: '代理商ID',
    agentIdPlaceholder: '请输入代理商ID',
    pending: '待结算',
    settled: '已结算',
    cancelled: '已取消',
    orderNo: '订单编号',
    agentName: '代理商',
    commissionAmount: '分润金额',
    orderAmount: '订单金额',
    settle: '结算',
    view: '查看',
    editRoute: '编辑推广路线',
    editConfig: '编辑配置',
    selectLibPlaceholder: '请选择机构类型',
    toggleStatusConfirm: '确定要{action}该路线吗？',
    statusUpdateSuccess: '状态更新成功',
    statusUpdateFailed: '状态更新失败',
    deleteConfirm: '是否确认删除？删除后不可恢复！',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    selectRouteFirst: '请先选择推广路线',
    batchSaveFeature: '批量保存配置功能待实现',
    settleConfirm: '确定要结算该分润记录吗？',
    settleSuccess: '结算成功',
    settleFailed: '结算失败',
    viewFeature: '查看详情功能待实现',
    routeNameRequired: '路线名称必填',
    routeCodeRequired: '路线编码必填',
    libIdRequired: '机构类型必选',
    levelRequired: '层级必填',
    commissionRateRequired: '分润比例必填',
    unknown: '未知'
  },

  // 管理员账号管理
  equUser: {
    title: '管理员账号管理',
    userName: '用户账号',
    userNamePlaceholder: '请输入用户账号',
    userNameRequired: '用户账号必填',
    status: '状态',
    statusPlaceholder: '请选择状态',
    statusRequired: '状态必选',
    allStatus: '全部',
    normal: '正常',
    disabled: '禁用',
    unknown: '未知',
    isSuperAdmin: '超级管理员',
    userType: '用户类型',
    userTypeRequired: '用户类型必选',
    superAdmin: '超级管理员',
    normalUser: '普通用户',
    yes: '是',
    no: '否',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    addUser: '添加账号',
    editUser: '编辑用户',
    resetPassword: '密码重置',
    resetPasswordConfirm: '要将密码重置为：123456吗？',
    resetPasswordSuccess: '密码重置成功',
    resetPasswordFailed: '密码重置失败',
    permissionControl: '权限控制',
    defaultPassword: '密码：默认123456',
    getUserListFailed: '获取用户列表失败',
    getPermissionsFailed: '获取用户权限失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    savePermissionsSuccess: '权限保存成功',
    savePermissionsFailed: '权限保存失败'
  }
}